import { Flex, Tag as AntdTag, Button } from "antd"
import styles from "./index.module.css"
import { PlusOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"

const GroupTags = ({
  setIsGroupModalVisible,
  setSelectedGroups,
  setGroupAction,
  setSelectedClientIds,
  client,
  setRemoveGroups,
  setIsMenuListHide,
  canEditClient
}) => {
  const { client_groups } = client || {}
  const firstGroup = client_groups?.[0] || {}
  const { color, name } = firstGroup || {}

  const handleManageGroup = () => {
    setIsGroupModalVisible(true)
    setSelectedGroups(client_groups)
    setGroupAction("add")
    setSelectedClientIds([client.id])
    setRemoveGroups([])
    setIsMenuListHide?.(false)
  }

  const hasGroups = client_groups?.length > 0

  return (
    <>
      {hasGroups ? (
        <Flex
          gap={2}
          onClick={canEditClient ? handleManageGroup : undefined}
          style={{ cursor: canEditClient ? "pointer" : "not-allowed", opacity: canEditClient ? 1 : 0.5 }}
        >
          <AntdTag title={name} style={{ color: color, backgroundColor: color + "26" }} className={`px-s py-xxs ${styles.tag} ellipsis`}>
            {name}
          </AntdTag>
          {client_groups.length > 1 && (
            <Button className={`px-xs ${styles.countButton}`} shape="circle" disabled={!canEditClient}>
              +{client_groups.length - 1}
            </Button>
          )}
        </Flex>
      ) : (
        <Button
          icon={<PlusOutlined />}
          iconPosition="start"
          className={`${styles.addButton}`}
          gap={2}
          onClick={canEditClient ? handleManageGroup : undefined}
          disabled={!canEditClient}
        >
          Group
        </Button>
      )}
    </>
  )
}

GroupTags.propTypes = {
  setIsGroupModalVisible: PropTypes.func,
  setSelectedGroups: PropTypes.func,
  setGroupAction: PropTypes.func,
  setSelectedClientIds: PropTypes.func,
  client: PropTypes.object,
  setRemoveGroups: PropTypes.func,
  setIsMenuListHide: PropTypes.func,
  canEditClient: PropTypes.bool
}

export default GroupTags
